import React from 'react';
import Alert from './Alert';
import classNames from 'classnames';
import {ALERT__24} from '@homeaway/svg-defs';

function AlertDanger(props) {
    let buttonClasses = classNames('Alert--danger', props.className);
    return (
        <Alert {...props} className={buttonClasses} flairClassName="bg--color-negative" svgClassName="text-danger"/>
    );
}

AlertDanger.propTypes = {
    ...Alert.propTypes
};

AlertDanger.defaultProps = {
    ...Alert.defaultProps,
    ariaLive: 'assertive',
    svgMarkup: ALERT__24
};

export default AlertDanger;
